import { inject, Injectable } from '@angular/core';
import {
  AdobeDataLayerPayload,
  AdobeDataPages,
} from '../models/adobe-data-layer.model';
import { MlbStatsConnectionService } from './mlb-stats.service';
import { ConfigurationService } from './configuration.service';
import { lastValueFrom, Subject } from 'rxjs';
import { SaleEvent } from '@core/models';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { DemoDataService } from './demo-data.service';

@Injectable({
  providedIn: 'root',
})
export class AdobeDataLayerService {
  configurationService = inject(ConfigurationService);
  mlbStatsConnectionService = inject(MlbStatsConnectionService);
  router = inject(Router);
  pageEventSubject = new Subject<AdobeDataPages>();
  demoDataService = inject(DemoDataService);

  get teamId() {
    return Number(this.configurationService.configuration.teamId);
  }

  push(data: AdobeDataLayerPayload): void {
    if (this.demoDataService.isDemoActive()) {
      return;
    }
    console.log('Adobe Data Layer Push');
    console.table(data);
    const adobeDataLayer = (window as any).adobeDataLayer || [];
    return adobeDataLayer.push(data);
  }

  async getGamePK(): Promise<string> {
    if (this.demoDataService.isDemoActive()) {
      return '';
    }
    try {
      const response = await lastValueFrom(
        this.mlbStatsConnectionService.getSchedule()
      );
      let gamePk = '';
      response.dates.forEach(date => {
        if (gamePk) {
          return;
        }
        const game = date.games.find(game => {
          const isHomeTeamMatching = game.teams.home.team.id === this.teamId;
          const isAwayTeamMatching = game.teams.away.team.id === this.teamId;

          return isHomeTeamMatching || isAwayTeamMatching;
        });

        if (game) {
          gamePk = game.gamePk.toString();
        }
      });

      return gamePk;
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  getEventId() {
    if (this.demoDataService.isDemoActive()) {
      return '';
    }
    const eventId = localStorage.getItem('adobe-data-layer-eventId');
    return eventId || '';
  }

  setEventId(eventId: number | string) {
    if (this.demoDataService.isDemoActive()) {
      return;
    }
    localStorage.setItem('adobe-data-layer-eventId', eventId.toString());
  }

  getEvent(): SaleEvent {
    if (this.demoDataService.isDemoActive()) {
      return {} as SaleEvent;
    }
    const event = localStorage.getItem('adobe-data-layer-event');
    return event ? JSON.parse(event) : ({} as SaleEvent);
  }

  setEvent(event: SaleEvent) {
    if (this.demoDataService.isDemoActive()) {
      return;
    }
    localStorage.setItem('adobe-data-layer-event', JSON.stringify(event));
  }

  getMatchupFull() {
    if (this.demoDataService.isDemoActive()) {
      return '';
    }
    const event = this.getEvent();
    return `${event.description}-${event.date}`;
  }
}
